/**
 * Copies the text to the browser's clipboard
 * @param text {string} - text to copy
 */
import { APP_HOST } from '@/utils/constants/api';

const copy = (text) => {
  if (!navigator.clipboard) {
    // eslint-disable-next-line
        console.error('Browser does not support copying');
  } else navigator.clipboard.writeText(text);
};
export default copy;

/**
 * Copies the public link for some act
 * @param link {string} - public_key from the server
 */
export const copyShareLink = (link) => {
  copy(`${APP_HOST}/public/${link}`);
};
